import clsx from 'clsx'
import { CheckboxRegular } from '../form/CheckboxRegular'
import { LoadingSpinner } from '../shared/LoadingSpinner'
import style from './ProductFilterControl.module.sass'

export function FilterCheckbox(props: {
	name: string
	checked?: boolean
	value: string
	label: string
	onChange: (checked: boolean, value: string) => void
	dirty?: boolean
	disabled?: boolean
	count?: number
	spacing?: 0
}) {
	return (
		<div className={clsx(style.checkboxWrapper, style[`spacing_${props.spacing ?? 'default'}`])}>
			<CheckboxRegular
				noMargin
				label={props.label}
				disabled={props.disabled}
				count={props.count}
				checked={props.checked}
				onChange={(e) => {
					const checked = e.currentTarget.checked
					props.onChange(checked, props.value)
				}}
			/>
			<LoadingSpinner active={props.dirty} />
		</div>
	)
}
